import { ContactUsState, UserData } from './definitions';
export class ContactUsFactory
{
	public static build(): ContactUsState
	{
		return {
			loading: false,
			pageHeading: 'Contact Us',
			sectionTopHeading: 'Tell us about yourself',
			sectionTopData: [
				{
					label: 'First Name',
					placeholder: 'First Name',
					errorMsg: 'First Name is required',
					isRequired: true,
					id: 'firstName',
					type: 'text'
				},
				{
					label: 'Last Name',
					placeholder: 'Last Name',
					errorMsg: 'Last Name is required',
					isRequired: true,
					id: 'lastName',
					type: 'text'
				},
				{
					label: 'Email',
					placeholder: 'abcd@email.com',
					errorMsg: 'Email is required',
					isRequired: true,
					id: 'email',
					type: 'email'
				},
				{
					label: 'Phone',
					placeholder: '(888) 888-8888',
					errorMsg: 'Phone is required',
					isRequired: true,
					id: 'phone',
					type: 'text'
				},
				{
					label: 'Company Name',
					placeholder: 'Company Name',
					errorMsg: 'Company Name is required',
					isRequired: true,
					id: 'companyName',
					type: 'text'
				},
				{
					label: 'Address',
					placeholder: 'Address',
					errorMsg: 'Address is required',
					isRequired: false,
					id: 'address',
					type: 'text'
				},
				{
					label: 'Country',
					placeholder: 'abcd@email.com',
					errorMsg: 'Country is required',
					isRequired: true,
					id: 'country',
					type: 'select'
				},
				{
					label: 'State',
					placeholder: 'State',
					errorMsg: 'State is required',
					isRequired: false,
					id: 'state',
					type: 'select'
				},
				{
					label: 'City',
					placeholder: 'City',
					errorMsg: 'City is required',
					isRequired: false,
					id: 'city',
					type: 'text'
				},
				{
					label: 'ZipCode',
					placeholder: 'ZipCode',
					errorMsg: 'ZipCode is required',
					isRequired: false,
					id: 'zipCode',
					type: 'text'
				}
			],
			pageSubHeading: 'Please fill out the form below with your details and message. Our team will review your inquiry and get back to you within 3-4 business days.',
			sectionBottomHeading: 'What can we help you with?',
			sectionBottom: {
				dropdownLabel: 'Reason',
				isRequired: true,
				errorMsg: 'Reason is required',
				dropDownData: [
					{
						label: 'Log In/ Registration',
						subMenu: [],
						isOpen: false
					},
					{
						label: 'My Toyota Account',
						subMenu: [],
						isOpen: false
					},
					{
						label: 'MyToyota Store',
						subMenu: [
							{ label: 'Parts Order' },
							{ label: 'Equipment Order' },
							{ label: 'Checkout Issue' }
						],
						isOpen: false
					},
					{
						label: 'Product/Equipment Information',
						subMenu: [
							{ label: 'Manuals' },
							{ label: 'Part Information' },
							{ label: 'Other' }
						],
						isOpen: false
					},
					{
						label: 'Billing Question',
						subMenu: [{ label: 'Invoice' }],
						isOpen: false
					},
					{
						label: 'New Equipment Order',
						subMenu: [
							{ label: 'MyToyota Store Equipment Order' },
							{ label: 'Toyota Dealer Equipment Order' }
						],
						isOpen: false
					},
					{
						label: 'MyInsights',
						subMenu: [],
						isOpen: false
					},
					{
						label: 'Feedback',
						subMenu: [],
						isOpen: false
					},
					{
						label: 'Other',
						subMenu: [],
						isOpen: false
					}
				]
			},
			buttons: {
				submit: {
					size: 'small',
					style: 'primary',
					disabled: true,
					label: 'Submit',
					icon: {
						altText: '',
						iconPath: ''
					},
					position: 'left'
				},
				cancel: {
					size: 'small',
					style: 'secondary',
					disabled: false,
					label: 'Cancel',
					icon: {
						altText: '',
						iconPath: ''
					},
					position: 'left'
				}
			},
			response: { data: {}, isInvalid: false, emailErrorMessage: '' },
			comments: {
				label: 'Comments',
				placeholder:
          'Please describe your issue and any details that can help us assist you better',
				errorMsg: 'Comments is required',
				type: 'textarea',
				id: 'comments',
				isRequired: true
			},
			toasterSuccess: { label: 'Form Submitted Successfully' },
			toasterFailure: { label: 'Form Submission Failed' },
			subreasonLabelData: {
				partInformation: [{
					label: 'Model-Serial (Optional)',
					placeholder: 'Enter Model-Serial'
				}],
				invoiceNumber: [{
					label: 'Invoice Number (Optional)',
					placeholder: 'Enter Invoice Number'
				}],
				partsOrder: [{
					label: 'Order Number (Optional)',
					placeholder: 'Enter Order Number'
				}],
				equipmentOrder: [{
					label: 'Order Number (Optional)',
					placeholder: 'Enter Order Number'
				}],
				manualInformation: [{
					label: 'Model-Serial  (Optional)',
					placeholder: 'Enter Model-Serial'
				}],
				myToyotaStoreEquipmentOrder: [{
					label: 'Order Number (Optional)',
					placeholder: 'Enter Order Number'
				}],
				toyotaDealerEquipmentOrder: [{
					label: 'Order Number (Optional)',
					placeholder: 'Enter Order Number'
				}]
			}
		};
	}

	public static buildContactData(): UserData
	{
		return {
			firstName: '',
			lastName: '',
			email: '',
			phoneNumber: '',
			companyName: '',
			addressLine1: '',
			city: '',
			state: '',
			zipCode: '',
			country: '',
			accountType: '',
			role: '',
			primaryLocationGRID: '',
			adminLocationID: '',
			crmRecordExists: false,
			customerType: ''
		 };
	}
}
